import {
  checkPermissions,
  CheckPermissionsOptions,
  HasPermissionsOptions,
} from 'features/permissions/utils/checkPermissions';
import { PermissionsState, PermissionTypes } from 'features/permissions/types';
import { User } from 'features/users/types';

export interface RefinePermissionsOptions extends HasPermissionsOptions {
  permissionsState: PermissionsState;
  localUser: User | undefined;
  isSystemSession?: boolean;
}

export const refinePermissions = (
  permissions: PermissionTypes | PermissionTypes[],
  options: RefinePermissionsOptions
) => {
  const {
    targetRole,
    role,
    targetUser,
    permissionsState,
    localUser,
    coverage,
    isSystemSession,
    mode,
  } = options;

  let identity: Pick<CheckPermissionsOptions, 'role' | 'dynamicPermissions'>;

  if (targetUser) {
    identity = { role: targetUser.role, dynamicPermissions: targetUser.dynamicPermissions };
  } else if (role) {
    identity = { role };
  } else if (localUser) {
    identity = { role: localUser.role, dynamicPermissions: localUser.dynamicPermissions };
  } else {
    return false;
  }

  return checkPermissions({
    permissionsState,
    permissions,
    targetRole,
    coverage,
    isSystemSession,
    mode,
    ...identity,
  });
};
